<template>
  <div>
    <AppTitle name="รายชื่อผู้ป่วย" />

    <div class="col-md-12">
      <div class="tile">
        <LoadingOverlay v-if="isLoading" />

        <div class="tile-title-w-btn">
          <h3 class="title">APACHE Patient List</h3>
        </div>

        <div class="tile-body">
          <div class="table-responsive">
            <table class="table table-striped table-hover table-bordered">
              <thead class="table-light text-center">
                <tr>
                  <th>#</th>
                  <th>CID</th>
                  <th>HN</th>
                  <th>AN</th>
                  <th>ชื่อ - สกุล</th>
                  <!-- <th>Ward</th> -->
                  <th>อายุ</th>
                  <th>Total Score</th>
                  <th>Mortality (%)</th>
                  <th>ดูข้อมูล</th>
                </tr>
              </thead>

              <tbody>
                <tr v-for="(item, index) in apacheList" :key="item.id">
                  <td>{{ index + 1 }}</td>
                  <td>{{ item.cid }}</td>
                  <td>{{ item.hn }}</td>
                  <td>{{ item.an }}</td>
                  <td>{{ item.name }}</td>
                  <!-- <td>{{ item.ward_name }}</td> -->
                  <td>{{ item.age }}</td>
                  <td>{{ item.total_score }}</td>
                  <td>{{ item.mortality }} %</td>
                  <td>
                    <button class="btn btn-info btn-sm" @click="viewItem(item)">
                      ดู
                    </button>
                  </td>
                </tr>

                <tr v-if="apacheList.length === 0 && !isLoading">
                  <td colspan="11" class="text-center">ไม่มีข้อมูล</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>

    <!-- VIEW MODAL -->
    <div class="modal fade" id="viewApacheModal" tabindex="-1">
      <div class="modal-dialog modal-lg modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">รายละเอียดผู้ป่วย</h5>
            <button class="btn-close" data-bs-dismiss="modal"></button>
          </div>

          <div class="modal-body" v-if="selectedItem">
            <h5 class="text-primary">ข้อมูลทั่วไป</h5>
            <p><b>ชื่อ:</b> {{ selectedItem.name }}</p>
            <p><b>CID:</b> {{ selectedItem.cid }}</p>
            <p><b>HN:</b> {{ selectedItem.hn }}</p>
            <p><b>AN:</b> {{ selectedItem.an }}</p>
            <p><b>ที่อยู่:</b> {{ selectedItem.address }}</p>
            <!-- <p><b>Ward:</b> {{ selectedItem.ward_name }}</p> -->

            <hr />

            <h5 class="text-success">Vital Signs</h5>
            <p><b>TEMP:</b> {{ selectedItem.temperature }}</p>
            <p><b>Mean Arterial Pressure:</b> {{ selectedItem.map }}</p>
            <p><b>Heart Rate:</b> {{ selectedItem.heart_rate }}</p>
            <p><b>Respiratory Rate:</b> {{ selectedItem.respiratory_rate }}</p>
            <p><b>Oxygenation (A-aDO₂):</b> {{ selectedItem.oxygenation_a }}</p>
            <p><b>Oxygenation (B-PaO₂):</b> {{ selectedItem.oxygenation_b }}</p>
            <p><b>Glasgow Coma Score:</b> {{ selectedItem.gcs }}</p>

            <hr />
            <!-- <pre>{{ selectedItem }}</pre> -->

            <h5 class="text-info">Laboratory Values</h5>
            <p><b>Arterial pH:</b> {{ selectedItem.arterial_ph }}</p>
            <p><b>Serum Sodium (mmol/L):</b> {{ selectedItem.serum_sodium }}</p>
            <p>
              <b>Serum Potassium (mmol/L):</b>
              {{ selectedItem.serum_potassium }}
            </p>
            <p>
              <b>Serum Creatinine (mg/100 ml):</b>
              {{ selectedItem.serum_creatinine }}
            </p>
            <p><b>Hematocrit (%):</b> {{ selectedItem.hematocrit }}</p>
            <p><b>White Blood Count (×1000):</b> {{ selectedItem.wbc }}</p>
            <p><b>Serum HCO₃ (mmol/L):</b> {{ selectedItem.serum_hco3 }}</p>

            <hr />

            <h5 class="text-danger">APACHE Score</h5>
            <p><b>APS:</b> {{ selectedItem.aps }}</p>
            <p><b>Total Score:</b> {{ selectedItem.total_score }}</p>
            <p><b>Mortality:</b> {{ selectedItem.mortality }}%</p>
          </div>

          <div class="modal-footer">
            <i>ผู้บันทึกข้อมูล: {{selectedItem?.recorder_name}}</i>
            <button class="btn btn-secondary" data-bs-dismiss="modal">
              ปิด
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from "vue";
import { Modal } from "bootstrap";
import api from "@/api/http";
import LoadingOverlay from "@/components/common/LoadingOverlay.vue";
import AppTitle from "@/components/layouts/AppTitle.vue";

const apacheList = ref([]);
const isLoading = ref(false);

const selectedItem = ref(null);
let viewModalInstance = null;

const fetchApache = async () => {
  isLoading.value = true;
  try {
    const res = await api.get("/apache");
    apacheList.value = res.data;
  } catch (e) {
    console.error("โหลดข้อมูลล้มเหลว:", e);
  } finally {
    isLoading.value = false;
  }
};

const viewItem = (item) => {
  selectedItem.value = item;
  const el = document.getElementById("viewApacheModal");
  viewModalInstance = new Modal(el);
  viewModalInstance.show();
};

onMounted(() => {
  fetchApache();
});
</script>

<style scoped>
.table-responsive {
  overflow-x: auto;
}

p {
  margin-bottom: 6px;
}
</style>
